import {make} from "vuex-pathify";
import moment from "moment";
import BotService from "@/services/bot.service";
import router from "@/router";
import AppService from "@/services/app.service";
import ReportService from "@/services/report.service";

const state = () => ({
    filter: {
        channel: '',
        skills: [],
        from: moment().subtract(6, 'day').format('YYYY-MM-DD'),
        to: moment().format('YYYY-MM-DD')
    },
    skillsFilterItems: [],
    autoAssignStatusManage: null,
    overviewReport: null,
    topicDistribution: null
})
const mutations = {
    ...make.mutations(state),
}
const actions = {
    ...make.actions(state),
    fetchAutoAssignStatusManage({commit}) {
        const botCode = router.currentRoute.params.bot_code;
        BotService.getAutoAssignStatus_manage(botCode)
            .then(res => {
                commit('SET_AUTO_ASSIGN_STATUS_MANAGE', res.data);
            })
            .catch(err => {
                AppService.toastError("Error", err.message);
            })
    },
    fetchOverviewReport({commit, state}) {
        const botCode = router.currentRoute.params.bot_code;
        ReportService.Overview(botCode, state.filter.channel, state.filter.skills, state.filter.from, state.filter.to)
            .then(res => {
                commit('SET_OVERVIEW_REPORT', res.data);
            })
    },
    fetchTopicDistribution({commit, state}, {topicLevel1Filter = '', page = 1, pageSize = 10, all = false} = {}) {
        const botCode = router.currentRoute.params.bot_code;
        ReportService.TopicDistribution(botCode, state.filter.from, state.filter.to, state.filter.channel, topicLevel1Filter, page, pageSize, all)
            .then(res => {
                commit('SET_TOPIC_DISTRIBUTION', res.data);
            })
            .catch(() => {
                commit('SET_TOPIC_DISTRIBUTION', {items: [], total_topics: 0, page: 1, page_size: pageSize, total_pages: 1});
            });
    }
}
const getters = {
    skillsFilterItems: state => {
        if (state.autoAssignStatusManage) {
            const categories = state.autoAssignStatusManage.rs_categories;
            return _.map(categories, o => {
                return {text: o.name, value: o.id}
            })
        }
        return [];
    }
}
export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}